import { api } from './config';
import API_CONFIG from './config';

class AGTCashFlowService {
  constructor() {
    // Asegúrate de que el endpoint corresponda al módulo Cash Flow en el backend
    this.baseURL = `${API_CONFIG.BASE_URL}/agt-cashflow`;
    this.conversations = new Map();
  }

  async sendMessage(message, context = {}) {
    try {
      const conversationId = this._getConversationId(context);
      
      const response = await api.post(`${this.baseURL}/chat`, {
        message,
        conversationId,
        context: {
          activeTab: context.activeTab,
          // Puedes enviar datos adicionales específicos de Cash Flow aquí
          cashFlowData: context.cashFlowData,
          timestamp: context.timestamp
        }
      });

      if (!response?.data?.success) {
        throw new Error('Failed to get response from AGT Cash Flow');
      }

      // Actualizar el contexto de la conversación
      this._updateConversationContext(conversationId, {
        lastMessage: message,
        lastResponse: response.data,
        ...context
      });

      return response;
    } catch (error) {
      console.error('Error communicating with AGT Cash Flow:', error);
      throw error;
    }
  }

  _getConversationId(context) {
    const existingConversation = Array.from(this.conversations.entries())
      .find(([_, ctx]) => ctx.userId === context.userId);
    
    if (existingConversation) {
      return existingConversation[0];
    }

    const conversationId = `cashflow_conv_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    this.conversations.set(conversationId, {
      userId: context.userId,
      startTime: new Date().toISOString(),
      activeTab: context.activeTab
    });
    return conversationId;
  }

  _updateConversationContext(conversationId, newContext) {
    const currentContext = this.conversations.get(conversationId) || {};
    this.conversations.set(conversationId, {
      ...currentContext,
      ...newContext,
      lastUpdated: new Date().toISOString()
    });
  }

  cleanupOldConversations(maxAge = 30 * 60 * 1000) {
    const now = Date.now();
    for (const [id, context] of this.conversations.entries()) {
      const conversationAge = now - new Date(context.startTime).getTime();
      if (conversationAge > maxAge) {
        this.conversations.delete(id);
      }
    }
  }
}

const agtCashFlowService = new AGTCashFlowService();

// Limpia conversaciones antiguas cada 15 minutos
setInterval(() => {
  agtCashFlowService.cleanupOldConversations();
}, 15 * 60 * 1000);

export default agtCashFlowService;
